import { Camera, IdCard, UserRoundSearch } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  AgentCore,
  ConnectionLines,
  GraphicCard,
  IllustrationFrame,
  StackedCard,
  VerifiedPill,
} from './shared'

/** A photo with the one thing this feature does drawn on it: the face it found, framed by a reticle. */
function PhotoWithFace({ title, found }: { title: string; found: string }) {
  return (
    <g>
      <StackedCard x={52} y={48} width={196} height={196} />
      <Camera x="68" y="63" width="20" height="20" className="text-primary-strong" />
      <text x="98" y="78" className="fill-foreground text-xs font-semibold">
        {title}
      </text>
      {/* the photo: a quiet scene with one person in it */}
      <rect x="68" y="96" width="164" height="118" rx="8" className="fill-primary/5" />
      <path d="M68 190Q110 160 150 184T232 176V214H68Z" className="fill-primary/10" />
      <circle cx="150" cy="140" r="17" className="fill-muted-foreground/25" />
      <path d="M118 194Q122 162 150 162T182 194Z" className="fill-muted-foreground/25" />
      {/* the detection reticle: four corners around the face, the mark of this feature */}
      <path
        d="M124 128V118H134 M166 118H176V128 M176 162V172H166 M134 172H124V162"
        className="stroke-primary"
        strokeWidth="2.5"
        strokeLinecap="round"
        fill="none"
      />
      <rect x="107" y="220" width="86" height="18" rx="9" className="fill-primary/15" />
      <text
        x="150"
        y="232.5"
        textAnchor="middle"
        className="fill-primary-strong text-3xs font-medium"
      >
        {found}
      </text>
    </g>
  )
}

export function FaceMatchingIllustration() {
  const { t } = useTranslation()
  const key = 'whatsNew.slides.faceMatching.graphic'
  return (
    <IllustrationFrame label={t(`${key}.description`)}>
      <ConnectionLines d="M248 145H285 M351 145H386Q402 145 402 128V79H437 M402 128V177H437" />
      <PhotoWithFace title={t(`${key}.photo`)} found={t(`${key}.found`)} />
      <AgentCore label={t(`${key}.matching`)} />
      <GraphicCard card={{ x: 437, y: 50, label: t(`${key}.identity`), icon: IdCard }} />
      <GraphicCard
        card={{ x: 437, y: 148, label: t(`${key}.candidates`), icon: UserRoundSearch }}
      />
      <circle cx="402" cy="128" r="4" className="fill-primary" />
      <VerifiedPill label={t(`${key}.confirmed`)} />
    </IllustrationFrame>
  )
}
